import { AppointmentsAvailabilityDto } from "@apiModels/AppointmentsAvailabilityDto.csharp";
import { LocationDto } from "@apiModels/LocationDto.csharp";

import { Filters } from "../../../Utils/Filters/types";
import { InsuranceDoctorDto } from "@apiModels/Insurance/InsuranceDoctorDto.csharp";

export const mapDoctorsToAppointment = (
  doctor: InsuranceDoctorDto,
  appointments: AppointmentsAvailabilityDto[],
  price: number | undefined,
  locations: LocationDto[],
  filters: Filters
) => {
  const appointmentsDataByDoctor = appointments.filter(
    (appointment) => appointment.doctorId == doctor.id && filters
  );

  if (filters.locations && filters.locations.length > 0) {
    const selectedCenters = filters.locations.flatMap((location) => {
      if (location.isLocation) {
        const locationCenters = location.centers;
        return locations.filter((l) => locationCenters.includes(l.id));
      }

      return [location];
    });

    const appointmentsDataByDoctorAndLocations =
      appointmentsDataByDoctor.filter((appointment) =>
        selectedCenters.some((center) => center.id == appointment.centerId)
      );

    const [appointmentByDoctorLocation] = appointmentsDataByDoctorAndLocations;
    if (appointmentByDoctorLocation) {
      return {
        ...doctor,
        date: new Date(appointmentByDoctorLocation.date),
        price: price,
      };
    }
  }

  const [appointmentByDoctor] = appointmentsDataByDoctor;
  if (appointmentByDoctor) {
    return {
      ...doctor,
      date: new Date(appointmentByDoctor.date),
      price: price,
    };
  }

  return { ...doctor, price: price };
};
